var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isShowable ? _c('div', {
    staticClass: "giftcard-ats-popup",
    class: {
      'giftcard-ats-popup--active': _vm.shows
    },
    attrs: {
      "max-width": "500",
      "width": _vm.$vuetify.breakpoint.lgAndUp ? '50%' : '90%',
      "scrollable": ""
    }
  }, [_c('v-card', [_c('v-img', {
    attrs: {
      "eager": "",
      "src": "/images/giftcard/giftcard_kakao_popup.jpg"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "flat": "",
      "color": "rgba(0, 0, 0, 0)"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1), _c('div', {
    staticClass: "popup-layer-foot",
    staticStyle: {
      "display": "flex",
      "background-color": "#424242",
      "padding": "10px"
    }
  }, [_c('v-checkbox', {
    staticClass: "white--text",
    attrs: {
      "color": "#fff",
      "label": "오늘 하루 열지않음",
      "hide-details": ""
    },
    on: {
      "click": _vm.close
    },
    model: {
      value: _vm.doNotOpenToday,
      callback: function callback($$v) {
        _vm.doNotOpenToday = $$v;
      },
      expression: "doNotOpenToday"
    }
  })], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }